export default __webpack_public_path__ + "static/media/richmond.2806a976.jpg";